import { ScheduleColumnData } from '@data/schedules/types/ScheduleColumnData';
import { BlockReleaseApiResponse } from '@data/blockReleases/types/BlockRelease.types';
import { convertBlockInfoToReleaseObject } from '@components/BlockRelease/utils/convertBlockInfoToReleaseObject';
import { isNonReleasedSurgeonBlock } from '@components/SchedulePage/utilities/blockTimeframeUtils/blockTimeframeUtils';

export const combineConvertedReleases = (
	surgeonSchedule: ScheduleColumnData,
	releases: BlockReleaseApiResponse[],
	surgeonNpi: string | null,
	hospitalName: string  | undefined,
	hospitalTimeZone: string | undefined,
): BlockReleaseApiResponse[] => {

	if (surgeonSchedule.blocks?.length && hospitalName && surgeonNpi && hospitalTimeZone) {
		const surgeonBlock = surgeonSchedule.blocks.filter(isNonReleasedSurgeonBlock)[0];
		const blockReleaseInfo = convertBlockInfoToReleaseObject(surgeonBlock, hospitalName, surgeonNpi, hospitalTimeZone);

		if (blockReleaseInfo) {
			return [...releases, blockReleaseInfo];
		}
	}
	return releases;
};
